import { ErrorScreen } from "@components/ui-kit";
import { t } from "@lingui/macro";

export const NotFoundBrand = () => (
  <ErrorScreen
    title={t`I didn’t find the brand you are looking for.`}
    link={{
      text: t`See all brands`,
      href: "/brands",
    }}
  />
);
